module.exports = __webpack_public_path__ + "static/premia-ee7126aea4e076d8fc624a77fa58d151.jpg";